module.exports = __webpack_public_path__ + "img/Ins_Current_L3.0f3a010d.jpeg";